export default "/assets/030362b90f6b2b4c.svg"